import moment from 'moment';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QuestionnaireService} from "../../../../services/questionnaire/questionnaire.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import { debounceTime } from 'rxjs/operators';
import { pipe } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
@Component({
  selector: 'app-questionnaire-list',
  templateUrl: './questionnaire-list.component.pug',
  styleUrls: ['./questionnaire-list.component.scss'],
  standalone: false
})
export class QuestionnaireListComponent implements OnInit {
  @Input() questionnaireList: any;
  @Input() surveyType: any;
  @Output() questionnaire = new EventEmitter();
  questionnaireSelected = 0;
  paginationCriteria = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  searchCriteria = {
    searchOptions: [
      {'label': $localize`Survey`, 'hint': $localize`Survey title`, 'value': 'title'},
      {'label': $localize`Created by`, 'hint': $localize`First or last name`, 'value': 'name'}],
    searchTerm: ''
  }
  sortCriteria = {
    sortOptions: [
      {
        'label': $localize`Last used`,
        'type': "number",
        'value': "last_used"
      },
      {
        'label': $localize`Times used`,
        'type': "number",
        'value': "count"
      },
    ],
    sortString: '-last_used',
    sortOrder: ''
  }
  survey_type_map = QuestionnaireService.survey_type_mapping;
  requestTemplate = false;
  loaded = false;
  constructor(
    private questionnaireService: QuestionnaireService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService
  )
  {
  }

  ngOnInit(): void {
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    if(this.requestTemplate){
        this.sortCriteria.sortOptions[1]['type'] = "frequency"
    }
    this.getQuestionnaireList();
  }

  selectedQuestionnaire(questionnaire) {
    this.questionnaireSelected = questionnaire.id;
    this.questionnaire.emit(questionnaire)
  }

  onSortChange(sortString: string): void {
    this.sortCriteria.sortString = sortString;
    this.getQuestionnaireList();
  }

  onSearchChange(searchOutput) {
    this.searchCriteria.searchTerm = searchOutput;
    this.getQuestionnaireList();
  }

  onPageChange(pageNumber) {
    this.paginationCriteria.currentPage = pageNumber;
    this.getQuestionnaireList();
  }

  onPageSizeChange(rowsPerView) {
    this.paginationCriteria.rowsPerView = rowsPerView;
    this.paginationCriteria.currentPage = 1;
    this.getQuestionnaireList();
  }

  getQuestionnaireList() {
    if(this.requestTemplate){
        this.loaded = false
    }
    const is_default = null;
    const type = this.survey_type_map[this.surveyType] ? this.survey_type_map[this.surveyType] : 1;
    this.questionnaireService.getQuestionnaires(
      this.searchCriteria.searchTerm, this.paginationCriteria.rowsPerView, this.paginationCriteria.currentPage, this.sortCriteria.sortString, is_default, type, true
    ).pipe(debounceTime(1000)).subscribe(response => {
      if(this.requestTemplate){
        this.loaded = true
      }
      this.questionnaireList = response['data']['questionnaires'];
      this.updateLastUsedDateFormat();
      this.paginationCriteria.total = response['data']['total'];
    }, error => {
      console.log(error);
      if(this.requestTemplate){
        this.loaded = true
      }
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  updateLastUsedDateFormat() {
    this.questionnaireList.forEach(question => {
      question.last_used = question.last_used ? moment.utc(question.last_used).local().format('ll') : ''
    });
  }

}
